export { default } from "./ProductImage";
